import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getOracleLists({ commit }, params) {
    return api.oracleManagement
      .getOracleList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_ORACLE_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
